import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useContext } from 'react';
import AppContext from 'src/AppContext';
import { OptimizationPayload, SmoothInput, TableViewInput } from '../../generated/types';

const mutation = `mutation Smooth($input: SmoothInput!) {
    smooth(input: $input) {
        measurementId
        succeeded
    }
}`;

export const useSmoothing = (measurementId: string, folderId: string) => {
    const context = useContext(AppContext);
    const queryClient = useQueryClient();

    return useMutation(
        async (smoothingIntensity: number) => {
            await context.populateCacheForAppSynch?.();

            const input: SmoothInput = {
                measurementId,
                smoothingIntensity,
            };

            const response = await (context.api.graphql({
                query: mutation,
                variables: { input },
            }) as Promise<{
                data: {
                    smooth: OptimizationPayload;
                };
            }>);

            return response.data.smooth.succeeded;
        },
        {
            onSettled: async () => {
                await queryClient.invalidateQueries({
                    predicate: q =>
                        (q.queryKey[0] === 'getMeasurementTableView' && (q.queryKey[1] as TableViewInput).id === measurementId && (q.queryKey[1] as TableViewInput).version === undefined) ||
                        (q.queryKey[0] === 'getMeasurementHistory' && q.queryKey[1] === measurementId) ||
                        (q.queryKey[0] === 'folderContent' && q.queryKey[1] === folderId),
                    type: 'all', // also inactive
                });
            },
        },
    );
};